import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2692712e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "header-container",
  "aria-hidden": "true"
}
const _hoisted_2 = ["hidden"]
const _hoisted_3 = {
  id: "title",
  class: "title-item"
}
const _hoisted_4 = {
  id: "subtitle",
  class: "title-item"
}
const _hoisted_5 = { id: "timer-container" }
const _hoisted_6 = {
  key: 0,
  id: "displayName",
  class: "displayName"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CountdownTimer = _resolveComponent("CountdownTimer")!
  const _component_PauseButton = _resolveComponent("PauseButton")!
  const _component_ExitButton = _resolveComponent("ExitButton")!
  const _component_PreviewMode = _resolveComponent("PreviewMode")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "inner-container",
      style: _normalizeStyle({ width: _ctx.width, maxWidth: _ctx.maxWidth, minHeight: _ctx.getMinimumHeight() })
    }, [
      _createElementVNode("div", {
        id: "title-container",
        hidden: _ctx.hideTitleContainer
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.subtitle), 1)
      ], 8, _hoisted_2),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.showDisplayName())
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.displayName), 1))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_CountdownTimer, {
          id: "countdown-timer",
          "timer-delivery-option": _ctx.timerDeliveryOption,
          "pause-test": _ctx.pauseTest
        }, null, 8, ["timer-delivery-option", "pause-test"]), [
          [_vShow, _ctx.timerDeliveryOption]
        ]),
        (_ctx.displayPauseButton())
          ? (_openBlock(), _createBlock(_component_PauseButton, {
              key: 1,
              id: "pause-button"
            }))
          : _createCommentVNode("", true),
        (_ctx.displayExitButton())
          ? (_openBlock(), _createBlock(_component_ExitButton, {
              key: 2,
              id: "exit-button"
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_PreviewMode, {
        id: "preview-mode",
        text: _ctx.previewModeText,
        hidden: !_ctx.isPreviewMode
      }, null, 8, ["text", "hidden"])
    ], 4)
  ]))
}